// Blob.prototype.text() exists in every supported browser but not in jsdom,
// so tests (and any other FileReader-only environment) need the fallback.
export const blobToText = (blob: Blob): Promise<string> => {
  if (typeof blob.text === "function") {
    return blob.text();
  }
  return new Promise<string>((resolve, reject) => {
    const reader = new window.FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

export default blobToText;
